import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { baseUrl, userLocation, ipAddress, userName } from "../Univ.js";

function SparePartsPage() {
  const [rows, setRows] = useState([]);
  const [machines, setMachines] = useState([]);
  const [data, setData] = useState({
    machine: "",
    part_name: "",
    quantity: ""
  });

  useEffect(() => {
    fetchParts();
    fetchMachines();
  }, []);

  const fetchParts = () => {
    axios.get(baseUrl + "spare-parts/")
      .then(res => setRows(res.data))
      .catch(() => Swal.fire("Error", "Could not fetch spare parts", "error"));
  };

  const fetchMachines = () => {
    axios.get(baseUrl + "machines/")
      .then(res => setMachines(res.data))
      .catch(() => Swal.fire("Error", "Could not fetch machines", "error"));
  };

  const inputHandler = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const formSubmit = () => {
    if (!data.machine || !data.part_name || !data.quantity) {
      Swal.fire("Error", "All fields are required", "error");
      return;
    }

    const _formData = new FormData();
    _formData.append("machine", data.machine);
    _formData.append("part_name", data.part_name);
    _formData.append("quantity", data.quantity);
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);
    _formData.append("location", userLocation);

    axios.post(baseUrl + "spare-parts/", _formData, { headers: { "Content-Type": "multipart/form-data" } })
      .then(res => {
        Swal.fire({ title: "Spare Part Added", icon: "success", timer: 2000, showConfirmButton: false });
        setData({ machine: "", part_name: "", quantity: "" });
        fetchParts();
      })
      .catch(() => Swal.fire("Error", "Something went wrong", "error"));
  };

  const handleDelete = (id) => {
    Swal.fire({ title: "Confirm", text: "Are you sure?", icon: "warning", showCancelButton: true, confirmButtonText: "Yes" })
      .then(result => {
        if (result.isConfirmed) {
          axios.delete(baseUrl + "spare-parts/" + id + "/")
            .then(() => { Swal.fire("Deleted", "Spare Part deleted", "success"); fetchParts(); });
        }
      });
  };

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    { field: "machine", headerName: "Machine", flex: 1, renderCell: (params) => params.row.machine?.name || "Unknown" },
    { field: "part_name", headerName: "Part Name", flex: 1 },
    { field: "quantity", headerName: "Quantity", flex: 1 },
    {
      field: "edit", headerName: "Edit", renderCell: (params) => (
        <Link to={`/spare-part/edit/${params.row.id}`} target="_blank" className="btn btn-warning btn-sm">Edit</Link>
      ), width: 120
    },
    {
      field: "delete", headerName: "Delete", renderCell: (params) => (
        <button onClick={() => handleDelete(params.row.id)} className="btn btn-danger btn-sm">Delete</button>
      ), width: 120
    }
  ];

  return (
    <div className="container mt-4">
      {/* Form */}
      <div className="card p-4 mb-4">
        <h4>Add Spare Part</h4>

        <select name="machine" value={data.machine} onChange={inputHandler} className="form-control mt-3">
          <option value="">Select Machine</option>
          {machines.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}
        </select>

        <input type="text" className="form-control mt-3" placeholder="Part Name" name="part_name" value={data.part_name} onChange={inputHandler} />
        <input type="number" className="form-control mt-3" placeholder="Quantity" name="quantity" value={data.quantity} onChange={inputHandler} />

        <button className="btn btn-success mt-3" onClick={formSubmit}>Submit</button>
      </div>

      {/* DataGrid */}
      <div className="card p-3">
        <DataGrid rows={rows} columns={columns} pageSize={10} autoHeight components={{ Toolbar: GridToolbar }}
          sx={{ boxShadow: 4, border: 4, borderColor: "primary.light", "& .MuiDataGrid-cell:hover": { color: "primary.main" } }}
        />
      </div>
    </div>
  );
}

export default SparePartsPage;
